import React from 'react';
import { Grid, Box, Text } from 'wt-ui';
import TextWithTooltip from './TextWithTooltip';
import Units from './Units';
import AlertMe from './AlertMe';

const getEventTime = (event) => event.releaseTime || event.enum.releaseTime;

const gridVailable = () =>
  typeof window !== 'undefined' && window.CSS && window.CSS.supports && window.CSS.supports('display', 'grid');

const RowHeader = ({ toggleContent, event }) => {
  if (gridVailable()) {
    return (
      <Grid columns={['xsmall', 'flex', '250px']} background="transparent" direction="row">
        <Box background="transparent">{getEventTime(event)}</Box>
        <Box background="transparent" hoverEffect>
          {event.isParent ? (
            <Text
              onClick={() => {
                toggleContent();
              }}
            >
              {event.enum ? event.enum.displayName || event.enum.name : event.displayName || event.name}
            </Text>
          ) : (
            <TextWithTooltip toggleContent={toggleContent} event={event} />
          )}
        </Box>
        <Grid columns={['flex', '50px']}>
          <Grid columns={['1/3', '1/3', '1/3']} background="transparent" direction="row">
            <Box background="transparent">{event.value}</Box>
            <Box background="transparent">{event.prevValue}</Box>
            <Box background="transparent">
              {event.enum ? <Units units={event.enum.units} shortUnits={event.enum.shortUnits} /> : ''}
            </Box>
          </Grid>
          <Box background="transparent">
            <AlertMe event={event} />
          </Box>
        </Grid>
      </Grid>
    );
  }
  // older browsers like IE 11 do not support Grid element, use Box instead
  return (
    <Box background="transparent" direction="row" justify="between">
      <Box width="xsmall" background="transparent">
        {getEventTime(event)}
      </Box>
      <Box background="transparent" direction="row" fill justify="start">
        {event.isParent ? (
          <Text
            onClick={() => {
              toggleContent();
            }}
          >
            {event.enum ? event.enum.displayName || event.enum.name : event.displayName || event.name}
          </Text>
        ) : (
          <TextWithTooltip toggleContent={toggleContent} event={event} />
        )}
      </Box>
      <Box width="250px" background="transparent" direction="row" justify="between">
        <Box background="transparent" direction="row" gap="xsmall">
          <Box background="transparent" width="66.66px">{event.value}</Box>
          <Box background="transparent" width="66.66px">{event.prevValue}</Box>
          <Box background="transparent" width="66.66px">
            {event.enum ? <Units units={event.enum.units} shortUnits={event.enum.shortUnits} /> : ''}
          </Box>
        </Box>
        <Box background="transparent" width="50px">
          <AlertMe event={event} />
        </Box>
      </Box>
    </Box>
  );
};

export default RowHeader;
